import type { BenefitDetailDto, PersonDto } from "./benefit-types"
import { formatPersonName } from "./person-identity"

function recordedTotal(values: unknown[]): number | null {
  return values.every(value => typeof value === "number" && Number.isSafeInteger(value) && value >= 0)
    ? (values as number[]).reduce((sum, value) => sum + value, 0) : null
}

/** Display the server's saved counts, not a second browser implementation of age brackets. */
export function demographicsSummary(benefit: BenefitDetailDto) {
  const applicants = benefit.personCollection.filter(person => person.id === benefit.applicantId)
  return {
    members: benefit.personCollection.length,
    applicant: applicants.length === 1 ? formatPersonName(applicants[0]!) : "Unavailable",
    adults: recordedTotal([benefit.age18to59, benefit.age60Plus]),
    children: recordedTotal([benefit.age0to2, benefit.age3to5, benefit.age6to17]),
  }
}

/** Preserve every returned member; oldest first, absent/invalid birth dates last. */
export function demographicsRoster(people: PersonDto[]): PersonDto[] {
  const date = (person: PersonDto) => {
    const value = person.birthDate ? new Date(person.birthDate).getTime() : NaN
    return Number.isFinite(value) ? value : Infinity
  }
  return [...people].sort((left, right) => date(left) - date(right))
}
